import { render, staticRenderFns } from "./AddOrEditMaterial.vue?vue&type=template&id=80733716"
import script from "./AddOrEditMaterial.vue?vue&type=script&lang=js"
export * from "./AddOrEditMaterial.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditMaterial.vue?vue&type=style&index=0&id=80733716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports